import {
	setDebug,
	themeParams,
	initData,
	viewport,
	init as initSDK,
	mockTelegramEnv,
	type ThemeParamsType,
	retrieveLaunchParams,
	emitEvent,
	miniApp,
	backButton,
	postEvent,
} from '@tma.js/sdk-react'

/** Initializes the Telegram SDK and configures its dependencies. */
export async function init(options: {
	debug: boolean
	mockForMacOS: boolean
}): Promise<void> {
	setDebug(options.debug)
	initSDK()

	// Telegram for macOS has bugs around theme + safe-area requests; mock them.
	if (options.mockForMacOS) {
		let firstThemeSent = false
		mockTelegramEnv({
			onEvent(event, next) {
				if (event.name === 'web_app_request_theme') {
					let tp: ThemeParamsType = {}
					if (firstThemeSent) {
						tp = themeParams.state()
					} else {
						firstThemeSent = true
						tp = retrieveLaunchParams().tgWebAppThemeParams
					}
					return emitEvent('theme_changed', { theme_params: tp })
				}
				if (event.name === 'web_app_request_safe_area') {
					return emitEvent('safe_area_changed', {
						left: 0,
						top: 0,
						right: 0,
						bottom: 0,
					})
				}
				next()
			},
		})
	}

	backButton.mount.ifAvailable()
	initData.restore()

	if (miniApp.mount.isAvailable()) {
		themeParams.mount()
		miniApp.mount()
		// themeParams.bindCssVars()
		postEvent('web_app_setup_swipe_behavior', { allow_vertical_swipe: false })
		// Dark-only app: paint Telegram's own chrome/background dark. The
		// background color is what shows behind the webview when iOS scales it
		// down during the pull-to-minimize gesture — white by default. Set here
		// (before React mounts) so it's applied ahead of any early gesture.
		try {
			postEvent('web_app_set_header_color', { color: '#212121' })
			postEvent('web_app_set_background_color', { color: '#212121' })
			postEvent('web_app_set_bottom_bar_color', { color: '#212121' })
		} catch {
			// Older clients without these methods — CSS still forces the app dark.
		}
	}

	if (viewport.mount.isAvailable()) {
		viewport
			.mount()
			.then(() => {
				viewport.bindCssVars()
				viewport.expand()
			})
			.catch((err) => {
				console.error('[telegram] viewport mount failed', err)
			})
	}
}
